import React from 'react';
import { HeroSlideshow } from '../hero-slideshow';

interface StrapiSlide {
  id: number;
  title: string;
  subtitle: string;
  image?: {
    url: string;
    alternativeText?: string;
  };
  video?: {
    url: string;
  };
}

interface Props {
  slides: StrapiSlide[];
  locale: string;
}

export const Slideshow = ({ slides, locale }: Props) => {
  if (!slides || slides.length === 0) return null;

  const formattedSlides = slides.map((slide) => ({
    id: slide.id,
    title: slide.title,
    description: slide.subtitle,
    // Use video url if available, otherwise image url
    image: slide.video?.url || slide.image?.url || '',
  }));

  return <HeroSlideshow slides={formattedSlides} locale={locale} />;
};